import script from "./TrainBottomSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrainBottomSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TrainBottomSkeleton.vue?vue&type=style&index=0&id=715b59ea&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1008117636/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715b59ea"]])

export default __exports__